module.exports = __webpack_public_path__ + "static/img/08_02s.dd31ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250403/08_02s.png
// module id = itVv
// module chunks = 0